import slugify from "@sindresorhus/slugify"

const DICT_LONG_UMLAUTS = {
  ß: "ss",
  ä: "ae",
  ö: "oe",
  ü: "ue",
}

const DICT_SHORT_UMLAUTS = {
  ß: "ss",
  ä: "a",
  ö: "o",
  ü: "u",
}

export default function computeSlug(text: string, longUmlauts?: boolean): string {
  let slugText = text?.substring(0, 128)?.toLocaleLowerCase() ?? ""

  if (!longUmlauts) {
    slugText = slugText.replace(/ae/g, "a").replace(/oe/g, "o").replace(/ue/g, "u")
  }

  return slugify(slugText, {
    decamelize: false,
    customReplacements: longUmlauts ? Object.entries(DICT_LONG_UMLAUTS) : Object.entries(DICT_SHORT_UMLAUTS),
  })
}
